import * as React from "react";
import { DesignPage } from "../Components/DesignPage";
const DesignsPage = (props) => {
  return <DesignPage props={props} />;
};

export default DesignsPage;
